export default "__VITE_ASSET__2add6e9a__"